import { computed, reactive, type Ref } from 'vue';

const dirtySources = reactive(new Map<string, Ref<boolean>>());

const isDirty = computed(() => Array.from(dirtySources.values()).some((source) => source.value));

function registerDirtySource(id: string, source: Ref<boolean>): () => void {
  dirtySources.set(id, source);

  return () => {
    const current = dirtySources.get(id);
    if (current === source) {
      dirtySources.delete(id);
    }
  };
}

function unregisterDirtySource(id: string): void {
  dirtySources.delete(id);
}

export function useGlobalDirtyRegistry() {
  return {
    isDirty,
    registerDirtySource,
    unregisterDirtySource,
  };
}
